import { BaseAPICallsHandler } from "../BaseAPICallsHandler";
import { NetworkUtils } from "../NetworkUtils";
import { ServerConfig } from "../ServerConfig";
import { Delivery } from "../../../Models/Delivery";
import { Order } from "../../../Models/Order";

export class DeliveryAPIHandler {
  public static shared = new DeliveryAPIHandler();

  apiHandler = BaseAPICallsHandler.shared;
  serverConfig = ServerConfig.shared;
  networkUtils = NetworkUtils.shared;

  constructor();
  constructor(
    apiHandler: BaseAPICallsHandler,
    serverConfig: ServerConfig,
    networkUtils: NetworkUtils
  );
  public constructor(...params: any[]) {
    if (params.length >= 3) {
      this.apiHandler = params[0];
      this.serverConfig = params[1];
      this.networkUtils = params[2];
    }
  }

  public async createDelivery(deliveryData: any, orderId: string): Promise<Delivery> {
    const url = this.serverConfig.deliveryAPIs.createDelivery(orderId);
    const authHeaders = this.networkUtils.addAuthHeaders({});

    try {
      const response = await this.apiHandler.makePostRequest(authHeaders, url, deliveryData);
      const data = response.data.delivery;
      const delivery = new Delivery(data);
      return Promise.resolve(delivery);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  public async getSellerDeliveryByOrderId(orderId: string): Promise<Delivery> {
    const url = this.serverConfig.deliveryAPIs.getSellerDelivery(orderId);
    const authHeaders = this.networkUtils.addAuthHeaders({});

    try {
      const response = await this.apiHandler.makeGetRequest(authHeaders, url);
      const data = response.data as Delivery;
      return Promise.resolve(data);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  public async getBuyerDeliveryByOrderId(orderId: string): Promise<{delivery: Delivery, order: Order}> {
    const url = this.serverConfig.deliveryAPIs.getBuyerDelivery(orderId);
    const authHeaders = this.networkUtils.addAuthHeaders({});

    try {
      const response = await this.apiHandler.makeGetRequest(authHeaders, url);
      const delivery = new Delivery(response.data.delivery);
      const order = new Order(response.data.order);
      return Promise.resolve({
        delivery, order
      });
    } catch (err) {
      return Promise.reject(err);
    }
  }
}